import { useFundFamilyList } from "gen/endpoints/fund-family/fund-family";
import { useTranslation } from "react-i18next";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectElement } from "shared/components/input/select/SelectOption";

export const FundFamilyFormSelect: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const { data: fundFamilies } = useFundFamilyList(undefined);

  const fundFamilyElements =
    fundFamilies?.map<SelectElement>((fundFamily) => ({
      value: fundFamily.id!.toString(),
      rich_value: fundFamily.name,
    })) ?? [];

  return (
    <FormSelect
      name="fund_family_id"
      title={t("common:fundFamily")}
      elements={fundFamilyElements}
    />
  );
};
